export interface StipulationListKeyArguments {
  approvalId: string;
  openOnly?: boolean;
}

export interface StipulationHistoryKeyArguments {
  approvalId: string;
  stipCode: string;
  applicantPk?: number;
}

/**
 * Hierarchical query-key factory for the stipulations feature. The
 * shape encodes the cache hierarchy: invalidating `all` flushes every
 * stipulation query, `lists()` only flushes list queries. Never write
 * a literal key array outside this module — the factory IS the schema.
 *
 * `approvalId` is its own key segment (not nested in an object) so
 * `listsForApproval(approvalId)` can partial-match just that approval's
 * cached lists, instead of scanning every cached approval's lists and
 * filtering in JS.
 *
 * The list key includes `openOnly` because it is a real server-side
 * filter on the BFF (GET .../stipulations?openOnly=…): open-only and
 * full lists are distinct server payloads and must not share a cache
 * entry.
 */
export const stipulationKeys = {
  all: ["stipulations"] as const,
  lists: () => [...stipulationKeys.all, "list"] as const,
  listsForApproval: (approvalId: string) => [...stipulationKeys.lists(), approvalId] as const,
  list: (arguments_: StipulationListKeyArguments) =>
    [...stipulationKeys.listsForApproval(arguments_.approvalId), arguments_.openOnly] as const,
  histories: () => [...stipulationKeys.all, "history"] as const,
  history: (arguments_: StipulationHistoryKeyArguments) => [...stipulationKeys.histories(), arguments_] as const,
};
